export default {
  common: 'all 300ms ease-out'
}
